import { useCallback } from "react"
import Scanner from "./scanner/scanner"
import { usePutAlterarProcesso } from "../../../../../data/api/gestao/processo-produto-setor/put-processo-produto-setor"
import { useSessaoAtual, useToastSaurus } from "../../../../../services/app";
import { useHistory, useLocation } from "react-router-dom";
import { CircularLoading } from "../../../../components";
import { useGetProcessoProdutoSetor } from "../../../../../data/api/gestao/processo-produto-setor/get-processo-produto-setor";
import { ProcessoProdutoSetorModel } from "../../../../../model/api/processo-produto-setor/processo-produto-setor-model";
import { isEmpty } from "lodash";
import { EnumStatusPedido } from "../../../../../model/enums/enum-status-pedido";
import { ProcessoProdutoSetorModelNovo } from "../../../../../model/api/processo-produto-setor/put-processo-produto-setor";
import { usePedidos } from "../../../../../hooks/pedidos";
import { Box, Button } from "@material-ui/core";
import { ProcurarIcon } from "../../../../components/icons";
import { useDialog } from "../../../../../services/app/providers/dialog-provider";

export const AdicionarPedidoEntregaFragment = () => {

    const history = useHistory();
    const { showToast } = useToastSaurus();

    const { putAlterarProcesso, carregando: carregandoPut } = usePutAlterarProcesso();
    const { getEmpresaSelecionada, carregando: carregandoSessaoAtual } = useSessaoAtual();
    const { getProcessoProdutoSetor, carregando: carregandoGetProduto } = useGetProcessoProdutoSetor();

    const carregando = carregandoPut || carregandoSessaoAtual || carregandoGetProduto

    const { alterarStatusPedidoEntregador } = usePedidos()
    const { abrirAssumirEntrega } = useDialog()

    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const modulo = query.get("modulo");


    const getProcessoProdutoSetorWrapper = useCallback(async () => {
        let query = '&pageSize=999999';
        const res = await getProcessoProdutoSetor(getEmpresaSelecionada()?.Id!, query);

        if (res.erro)
            throw res.erro;

        return res.resultado?.data.list as ProcessoProdutoSetorModel[];
    }, [getEmpresaSelecionada, getProcessoProdutoSetor])

    const buscarProdutos = useCallback(async (valores: string[]) => {
        const processos = await getProcessoProdutoSetorWrapper();

        return processos.filter(x => valores.filter(y => y)[0] === x.id)[0];
    }, [getProcessoProdutoSetorWrapper])

    const putAlterarProcessoWrapper = useCallback(async (valores: ProcessoProdutoSetorModelNovo) => {

        const processo = await buscarProdutos(valores.ids);

        if (isEmpty(processo)) {
            throw new Error('Erro ao tentar realizar a leitura.');
        }

        if (processo.status.codigo === EnumStatusPedido.EmEntrega) {
            throw new Error('Este pedido já foi alterado para entrega. Selecione outros produtos para realizar a entrega.')
        }

        const proximoProcesso = processo.processoProducaoAtual + 1;

        const res = await putAlterarProcesso(valores, getEmpresaSelecionada()?.Id!, proximoProcesso);
        if (res.erro) throw res.erro

        showToast('success', 'Pedido alterado para entrega com sucesso.');
        history.replace('/')
    }, [buscarProdutos, getEmpresaSelecionada, history, putAlterarProcesso, showToast])

    const mudarStatusProcesso = useCallback(async (valores: ProcessoProdutoSetorModelNovo) => {
        try {
            await putAlterarProcessoWrapper(valores);
        }
        catch (err: any) {
            showToast('error', err.message);
        }
    }, [putAlterarProcessoWrapper, showToast])

    const codigoFormatado = useCallback((codigo: string) => {
        let codigoArray = codigo.split(';');

        return codigoArray;
    }, [])

    const leituraRealizada = async (codigo: string) => {
        if (modulo === 'motoboy') {
            abrirAssumirEntrega({
                onClickAssumir: async (alterarStatusEntrega?: boolean) => {
                    const sucesso = await alterarStatusPedidoEntregador(codigo, alterarStatusEntrega)
                    if (sucesso) {
                        history.goBack()
                        return
                    }
                },
                aberto: true,
            })
            return
        };
        const valor = codigoFormatado(codigo);
        await mudarStatusProcesso(new ProcessoProdutoSetorModelNovo(valor, true));
    }

    return (
        <>
            {carregando && <CircularLoading tipo="FULLSIZED" />}
            <div style={{ overflow: 'auto', height: '100%' }}>
                <Scanner inicialOrSecundario={false} onScan={leituraRealizada} />
                {modulo === 'motoboy' && (
                    <Box position="absolute" bottom={0} left={0} width="100%" display="flex" justifyContent="center" alignItems="center" p={2}>
                        <Button variant="contained" color="primary" fullWidth size="large" onClick={() => { history.push('/pedidos-para-entrega') }}>
                            <ProcurarIcon tipo="BUTTON_PRIMARY" />
                            Buscar pedidos
                        </Button>
                    </Box>
                )}
            </div>
        </>
    )
}